import React, { useState, useMemo } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
  TableSortLabel,
  TextField,
  IconButton,
  Collapse
} from '@mui/material';
import { visuallyHidden } from '@mui/utils'; 
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const headCells = [
  { id: 'supplier_id', label: 'شمیره' },
  { id: 'supplier_name', label: 'نوم' },
  { id: 'contact_person', label: 'د تماس کس' },
  { id: 'phone_number', label: 'د تلیفون شمیره' },
  { id: 'address', label: 'آدرس' },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export default function SuppliersList({ rows }) {
  //console.log(rows)
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('supplier_id');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filters, setFilters] = useState({
    supplier_id: '',
    supplier_name: '',
    contact_person: '',
    phone_number: '',
    address: '',
  });
  const [openRows, setOpenRows] = useState({});

  // Handle Sorting
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'desc';
    setOrder(isAsc ? 'asc' : 'desc');
    setOrderBy(property);
  };

  // Handle Filtering
  const handleFilterChange = (event, column) => {
    setFilters((prev) => ({ ...prev, [column]: event.target.value }));
  };

  // Filter and Sort Rows
  const filteredRows = useMemo(() => {
    return rows
      .filter((row) =>
        Object.keys(filters).every((key) =>
          // row[key]?.toString().toLowerCase().includes(filters[key].toLowerCase())
          // row[key]?.toString().toLowerCase()
          (String(row[key] || '')).toLowerCase().includes(filters[key].toLowerCase())
        )
      )
      .sort(getComparator(order, orderBy));
  }, [rows, filters, order, orderBy]);

  // Handle Pagination
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
 
  const toggleRow = (supplierId) => {
    setOpenRows((prev) => ({
        [supplierId]: !prev[supplierId] // Only the clicked row toggles, others collapse
    }));
};

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={'medium'}>
            <TableHead>
              <TableRow>
                <TableCell />
                {headCells.map((headCell) => (
                  <TableCell key={headCell.id} sortDirection={orderBy === headCell.id ? order : false}>
                    <TableSortLabel
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : 'asc'}
                      onClick={(event) => handleRequestSort(event, headCell.id)}
                    >
                      {headCell.label}
                      {orderBy === headCell.id ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </Box>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                ))}
                {/* <TableCell>کړنې</TableCell> */}
              </TableRow>
              {/* Search Input Row */}
              <TableRow>
                <TableCell />
                {headCells.map((headCell) => (
                  <TableCell key={headCell.id}>
                    <TextField
                      variant="standard"
                      size="small"
                      fullWidth
                      value={filters[headCell.id]}
                      onChange={(event) => handleFilterChange(event, headCell.id)}
                      placeholder={`لټون ${headCell.label}`}
                    />
                  </TableCell>
                ))}
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                <React.Fragment key={row.supplier_id}>
                  <TableRow hover>
                    <TableCell>
                      <IconButton size="small" onClick={() => toggleRow(row.supplier_id)}>
                        {openRows[row.supplier_id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </IconButton>

                    </TableCell>
                    <TableCell>{row.supplier_id}</TableCell>
                    <TableCell>{row.supplier_name}</TableCell>
                    <TableCell>{row.contact_person}</TableCell>
                    <TableCell>{row.phone_number}</TableCell>
                    <TableCell>{row.address}</TableCell> 
                  </TableRow> 
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
}
